import numeral from 'numeral';

const MARKUP_PERCENTAGE = 15;
const FEE_PERCENTAGE = 15;
const INSURANCE_PERCENTAGE = 1.25;

export function calculateMarkup(estimate) {
  return calculate(estimate, MARKUP_PERCENTAGE);
}

export function calculateFee(estimate) {
  return calculate(estimate, FEE_PERCENTAGE);
}

export function calculateInsurace(estimate) {
  return calculate(estimate, INSURANCE_PERCENTAGE);
}

function calculate(estimate, percentage) {
  return numeral((estimate * (percentage / 100)).toFixed(2)).value();
}



// WEBPACK FOOTER //
// ./src/services/utils/proposal-util.js